module.exports = __webpack_public_path__ + "static/media/household.ce878539.svg";